
import { Component, forwardRef, input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { IMarketDTO } from '@app/core/models/tactical/market/market-dto.model';
import { MarketService } from '@app/core/services/http-services/tactical/market.service';
import { TranslateModule, TranslateService, _ } from '@ngx-translate/core';
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { KENDO_FORMFIELD } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { State } from '@progress/kendo-data-query';
import { Guid } from 'guid-typescript';
import { Subject, takeUntil } from 'rxjs';

_('App.SelectItem');
@Component({
  selector: 'app-market-selector',
  templateUrl: './market-selector.component.html',
  styleUrls: ['./market-selector.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MarketSelectorComponent),
      multi: true,
    },
  ],
  imports: [KENDO_DROPDOWNS, KENDO_FORMFIELD, KENDO_LABEL, TranslateModule, FormsModule],
})
export class MarketSelectorComponent implements ControlValueAccessor, OnInit, OnDestroy {
  showLabel = input<boolean>(false);

  private onTouched!: Function;
  private onChanged!: Function;

  selectedMarketId: Guid | null = null;
  defaultItem: { name: string; marketId: any } = { name: 'App.SelectItem', marketId: null };
  marketData: IMarketDTO[] = [];

  private readonly destroy$ = new Subject<void>();

  constructor(private readonly marketService: MarketService, private readonly translateService: TranslateService) {}

  gridState: State = {
    skip: 0,
    take: 100,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  ngOnInit(): void {
    this.marketService
      .query(this.gridState)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (d) => {
          this.translateService
            .get(this.defaultItem.name)
            .pipe(takeUntil(this.destroy$))
            .subscribe((res: string) => {
              this.defaultItem.name = res;
            });
          this.marketData = d.data;
          if (!this.selectedMarketId && this.marketData) {
            this.onSelect(this.marketData[0].marketId);
          }
        },
      });
  }

  writeValue(marketId: Guid) {
    if (marketId) {
      this.selectedMarketId = marketId;
    }
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  onSelect(marketId: any): void {
    this.selectedMarketId = marketId;
    this.onChanged(marketId);
    this.onTouched(marketId);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
